// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  worldId: __t.string().name("world_id"),
  playerId: __t.string().name("player_id"),
  headX: __t.f64().name("head_x"),
  headY: __t.f64().name("head_y"),
  destinationX: __t.option(__t.f64()).name("destination_x"),
  destinationY: __t.option(__t.f64()).name("destination_y"),
  pathJson: __t.string().name("path_json"),
  trailJson: __t.string().name("trail_json"),
  unitCount: __t.u32().name("unit_count"),
  status: __t.string(),
  speedPerSecond: __t.f64().name("speed_per_second"),
  combatTargetId: __t.option(__t.string()).name("combat_target_id"),
  respawnAtTick: __t.option(__t.u64()).name("respawn_at_tick"),
  updatedAt: __t.timestamp().name("updated_at"),
});
